import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/check-circle.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12ZM15.793 8.29297C16.1835 7.90244 16.8165 7.90244 17.207 8.29297C17.5976 8.68349 17.5976 9.31651 17.207 9.70703L11.207 15.707C10.8165 16.0976 10.1835 16.0976 9.79297 15.707L6.79297 12.707L6.72461 12.6309C6.40426 12.2381 6.42685 11.6591 6.79297 11.293C7.15908 10.9269 7.73809 10.9043 8.13086 11.2246L8.20703 11.293L10.5 13.5859L15.793 8.29297ZM23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as CheckCircleIcon };
